<template>
  <div>
      <SGPModalComponent
        v-if="mostrarModal"
        :mostrarHeader="false"
        :mostrarFooter="false"
        mostrarBody
        tamanho="sm"
        titulo=""
        @sgpModalFechar="cancelarDelecao"
        :toolbar="false"
      >
        <div class="sgp-confirmacao">
          <h2> {{ titulo }} </h2>
          <h5 class=""> {{ subtitulo }} </h5>

          <div class="container-botoes">
            <SGPFormBotaoComponent
              class=""
              color="grey-5"
              outlined
              @click="cancelarDelecao()"
              capitalize
            >{{ txtCancelar }}</SGPFormBotaoComponent>
            <!-- <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize" @click="cancelar()">{{ txtCancelar }}</button> -->
            <!-- <button class="mdn-Button mdn-Button--primary" @click="confirmar()">{{ txtConfirmar }}</button> -->

            <SGPFormBotaoComponent
              class=""
              color="primary"              
              @click="confirmarDelecao()"
              capitalize
            >{{ txtConfirmar }}</SGPFormBotaoComponent>
          </div>
        </div>
        
      </SGPModalComponent>
  </div>
</template>

<script>
export default {
  name: 'SGPConfirmacaoDelecaoComponent',
  
  props: {
    titulo : {
      type: String,
      riquired: false,
      default: 'Tem certeza disso?',
    },
    subtitulo : {
      type: String,
      riquired: false,
      default: 'Você tem certeza que deseja deletar?! Tome cuidado, pois essa ação pode ser irreversível.',
    },
    txtConfirmar: {
      type: String,
      required: true,
      default: 'Confirmar',
    },
    txtCancelar: {
      type: String,
      required: true,
      default: 'Cancelar',
    },
  },

  data () {
    return {
      mostrarModal: false
    }
  },

  emit: [
    // evento disparado com o clique do botão de cancelar
    'sgpCancelarDelecaoEmit',
    // evento disparado com o clique do botão de confirmar
    'sgpConfirmarDelecaoEmit'
  ],

  mounted () {
    this.mostrarModal = true
  },

  methods: {
    cancelarDelecao () {
      // this.mostrarModal = false;
      setTimeout ( () => {
        this.$emit('sgpCancelarDelecaoEmit');
      }, 800)
      
    },
    confirmarDelecao () {
      this.mostrarModal = false;
      this.$emit('sgpConfirmarDelecaoEmit');
    },
  }
}
</script>